import { describePolyMarketCached } from './describeOrder';

/** Poly trade label chain (Gitea #56): the relay's persisted market identity
 *  outranks the browser-local caches (it survives markets this browser never
 *  saw live — Grim's settled Angels case); the market-level cache covers
 *  live/locally-seen markets; the hex preview is the last resort. Matchup
 *  only — orientation stays on the row's own ledger side.
 *
 *  Lives in lib/ rather than in the My Trades view because the Recent Fills
 *  tape needs the same chain (#457) and ActivityTicker is not lazy-loaded. */
export function polyTradeLabel(marketLabel: string | null, conditionId: string): string {
  return (
    marketLabel ??
    describePolyMarketCached(conditionId)?.matchup ??
    (conditionId.length > 16
      ? `${conditionId.slice(0, 6)}…${conditionId.slice(-4)}`
      : conditionId)
  );
}
